export default "__VITE_ASSET__CsLlZNsm__"